import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class CategoryService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.category.listUrl, ServiceConfig.category.detailUrl);
  }
}



// WEBPACK FOOTER //
// ./src/services/category.service.ts